import axios from 'axios';
import { nanoid } from 'nanoid';
import { IS_MOBILE } from '@/utils/tool';

// axios.defaults.baseURL =import.meta.env.BASE_URL

axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';
axios.defaults.headers.timeout = 300000; // 设置请求超时时间为30秒
    
/**
 *
 */
window.addEventListener('storage', (storageEvent: StorageEvent) => {
  if (storageEvent.key === 'token') {
    const auth = getAuthorization(storageEvent.newValue);
    axios.defaults.headers.common['Authorization'] = auth;
  }
});
//     return () => {
//       window.removeEventListener("storage", storageChange);
//     };

/**
 * 设置请求头
 */
axios.interceptors.request.use(function (config) {
  config.headers['X-Request-ID'] = nanoid(16);

  //   config.headers["Accept-Language"] = localStorage.getItem("language") || "zh";
  return config;
});

/**
 * 处理移动端的接口发送
 */
axios.interceptors.request.use(
  (config) => {
    if (IS_MOBILE && config.url.startsWith('/api/pay/')) {
      // 将 URL 修改为 '/api/pay-h5/xxx'
      config.url = config.url.replace('/api/pay/', '/api/pay-h5/');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * 设置token
 * @param token
 */
export const setToken = (token: string) => {
  localStorage.setItem('token', token);
  const auth = getAuthorization(token);
  axios.defaults.headers.common['Authorization'] = auth;
};

export const getAuthorization = (token?: string) => {
  const _token = token || localStorage.getItem('token');
  return `Bearer ${_token}`;
};

export const getToken = () => {
  const token = localStorage.getItem('token');
  return token;
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? JSON.parse(user) : null;
};

export const logOut = () => {
  localStorage.removeItem('token');
};
